import React from "react";
import { LoadableImage } from "../../ui";
import hero from "../../assets/hero.JPG";
import style from "./Hero.module.css";

export const Hero = () => {
  return (
    <div className={style.hero}>
      <h1 className={style.visuallyHidden}>
        HomeCraft Masters — custom kitchen design and cabinetry
      </h1>
      <LoadableImage
        src={hero}
        alt="HomeCraft Masters kitchen interior"
        width={5760}
        height={3840}
      />
    </div>
  );
};
